import {
  SERVICES_SUBTITLE,
  SERVICES_TITLE,
  SERVICES_PANEL_LABEL,
  SERVICES_PANEL_HEADING,
  SERVICES_INTRO_PARAGRAPH,
  SERVICES_CARD_BTN,
  INPUT_BADGE,
  INPUT_CARD_DESC,
  OUTPUT_BADGE,
  OUTPUT_CARD_DESC,
  ADVISORY_CARD_DESC,
  FINANCIAL_CARD_DESC,
} from "../services";
import {
  ABOUT,
  CONTACT,
  ENGLISH,
  HERO_SUBTITLE,
  HERO_TITLE,
  HINDI,
  HOME,
  LANGUAGE,
  NAV_NEWS,
  PARTNER,
  STATS_CENTRE,
  STATS_CUSTOMER,
  STATS_FARMERS,
  STATS_LOCATION,
  STATS_PARTNERS,
  TEAM,
  TITLE,
  AS_SEEN_IN,
  NEWS_EYEBROW,
  NEWS_TITLE,
  NEWS_SUBTITLE,
  READ_ARTICLE,
  STATS_PRODUCTS,
  INPUT,
  INPUT_DESCRIPTION,
  INPUT_FEATURE_1,
  INPUT_FEATURE_2,
  INPUT_FEATURE_4,
  INPUT_FEATURE_5,
  INPUT_FEATURE_3,
  OUTPUT,
  OUTPUT_DESCRIPTION,
  OUTPUT_FEATURE_1,
  OUTPUT_FEATURE_2,
  OUTPUT_FEATURE_3,
  CROP_ADVISORY,
  CROP_ADVISORY_DESCRIPTION,
  CROP_ADVISORY_FEATURE_1,
  CROP_ADVISORY_FEATURE_2,
  CROP_ADVISORY_FEATURE_3,
  CROP_ADVISORY_FEATURE_4,
  CROP_ADVISORY_FEATURE_5,
  FINANCIAL,
  FINANCIAL_DESCRIPTION,
  FINANCIAL_FEATURE_1,
  FINANCIAL_FEATURE_2,
  CONTACT_US,
  ADDRESS_1,
  ADDRESS_2,
  ADDRESS_3,
  PHONE,
  EMAIL,
  FOUNDERS,
  HERO_EYEBROW,
  HERO_TITLE_EMPHASIS,
  NAV_CTA,
} from "../../navbar/menu";
import { TESTIMONIAL_DESCRIPTION, TESTIMONIAL_LABEL } from "../testimonial";
import { FOOTER_TAGLINE, FOOTER_QUICK_LINKS, FOOTER_LEGAL } from "../footer";
import { PARTNER_DESCRIPTION, PARTNER_EYEBROW, PARTNER_LABEL } from "../partner";
import {
  CONTACT_EYEBROW,
  CONTACT_LABEL,
  QUESTION_FORM_SUBTITLE,
  QUESTION_FORM_TITLE,
} from "../contact";
import {
  OUR_BRANDS_LABEL,
  BRANDS_HEADING,
  BRANDS_HEADING_EMPHASIS,
  BRANDS_SUBTITLE,
  BRAND_NUKRISHI_KICKER,
  BRAND_NUKRISHI_NAME,
  BRAND_NUKRISHI_DESC,
  BRAND_NUKRISHI_TAG_1,
  BRAND_NUKRISHI_TAG_2,
  BRAND_NUKRISHI_TAG_3,
  BRAND_AMERICANBULLS_KICKER,
  BRAND_AMERICANBULLS_NAME,
  BRAND_AMERICANBULLS_DESC,
  BRAND_AMERICANBULLS_TAG_1,
  BRAND_AMERICANBULLS_TAG_2,
  BRAND_VISIT_CTA,
} from "../brands";
import {
  ABOUT_EYEBROW,
  ABOUT_TITLE,
  ABOUT_TITLE_EMPHASIS,
  ABOUT_SUBTITLE,
  ABOUT_STORY_LABEL,
  ABOUT_STORY_HEADING,
  ABOUT_STORY_PARA_1,
  ABOUT_STORY_PARA_2,
  ABOUT_STORY_PARA_3,
  ABOUT_STATS_LABEL,
  ABOUT_STATS_HEADING,
  ABOUT_FOUNDERS_LABEL,
  ABOUT_FOUNDERS_HEADING,
  ABOUT_CTA_HEADING,
} from "../about";

export const hinTranslation = {
  [TITLE]: "फ़्रेशोकार्ट्ज़",
  [LANGUAGE]: "भाषा",
  [ENGLISH]: "अंग्रेजी",
  [HINDI]: "हिंदी",

  [HOME]: "होम",
  [ABOUT]: "अबाउट",
  [PARTNER]: "पार्टनर्स",
  [TEAM]: "टीम",
  [FOUNDERS]: "संस्थापक",
  [CONTACT]: "संपर्क",
  [NAV_NEWS]: "समाचार",

  [HERO_EYEBROW]: "भारतीय कृषि का पुनर्निर्माण",
  [HERO_TITLE]: "भारतीय कृषि का कायाकल्प,",
  [HERO_TITLE_EMPHASIS]: "एक-एक खेत के साथ",
  [HERO_SUBTITLE]:
    "हमने अपने किसानों का समर्थन करने और अपने उत्पादों, कृषि विशेषज्ञ और शिक्षा प्लेटफार्मों के साथ अपनी उत्पादकता बढ़ाने के लिए भारतीय कृषि को फिर से तैयार करने के लिए खुद को समर्पित किया है।",
  [NAV_CTA]: "हमसे जुड़ें",

  [STATS_CENTRE]: "किसान केंद्र",
  [STATS_FARMERS]: "किसान",
  [STATS_LOCATION]: "राज्य",
  [STATS_CUSTOMER]: "व्यापार ग्राहक",
  [STATS_PARTNERS]: "भागीदार",
  [STATS_PRODUCTS]: "विभिन्न उत्पाद",

  [AS_SEEN_IN]: "जैसा देखा गया",
  [NEWS_EYEBROW]: "मीडिया में",
  [NEWS_TITLE]: "समाचार उल्लेख",
  [NEWS_SUBTITLE]: "नवीनतम समाचारों में हमारे आशय की जाँच करें ",

  [READ_ARTICLE]: "लेख पढ़ें",

  [INPUT]: "खाद/ बीज",
  [INPUT_DESCRIPTION]: "हम बीज, उर्वरक, कीटनाशक आदि प्रदान करते हैं।",
  [INPUT_FEATURE_1]: "💸 पाएं सबसे उचित मूल्य पर कृषी दवाई, खाद और बीज।",
  [INPUT_FEATURE_2]: "🚪 24 घंटे में घर बैठे मुफ्त डिलीवरी।",
  [INPUT_FEATURE_3]: "📞 आप फोन कॉल पर ऑर्डर भी दे सकते हैं।",
  [INPUT_FEATURE_4]: "💯 उत्तम गुणवत्ता के खाद और बीज।",
  [INPUT_FEATURE_5]: "🛒 हमारे पास 10000 से अधिक विभिन्न प्रकार के उत्पाद हैं।",

  [OUTPUT]: "कृषि उत्पाद विक्रय",
  [OUTPUT_DESCRIPTION]:
    "किसान भाई अपने उत्पाद हमारे केंद्र पर आसानी से बेच सकते है।",
  [OUTPUT_FEATURE_1]: "🚚 बाजार से सीधा जुड़ाव।",
  [OUTPUT_FEATURE_2]: "⚖️ सही तौल और भाव एक ही जगह पर।",
  [OUTPUT_FEATURE_3]: "💸 उपज का तुरंत भुगतान।",

  [CROP_ADVISORY]: "फसल सलाह",
  [CROP_ADVISORY_DESCRIPTION]:
    "हमारे उत्कृष्ट कृषि विशेषज्ञ हमेशा आपके लिए हैं।",
  [CROP_ADVISORY_FEATURE_1]: "🔬 मिट्टी की जांच।",
  [CROP_ADVISORY_FEATURE_2]: "👨🏼‍🏭 मुफ्त फसल निरीक्षण।",
  [CROP_ADVISORY_FEATURE_2]: "👨🏼 मुफ्त फसल निरीक्षण।",
  [CROP_ADVISORY_FEATURE_3]: "❗️ कृषि रोग से समन्धित जानकारी ऐवं उपचार।",
  [CROP_ADVISORY_FEATURE_4]:
    "📕 मुफ्त किसान हेल्पलाइन द्वारा कटाई से बुवाई तक की समस्त जानकारी।",
  [CROP_ADVISORY_FEATURE_5]: "📣 24X7 सहायता केंद्र।",

  [FINANCIAL]: "फाइनेंस/ लोन",
  [FINANCIAL_DESCRIPTION]: "फाइनेंस और लोन की सुविधा।",
  [FINANCIAL_FEATURE_1]: "💸 कृषि लोन सहायता।",
  [FINANCIAL_FEATURE_2]: "🚜 कृषि उपकरणों पर वित्तिय सहायता।",

  [CONTACT_US]: "संपर्क करें",
  [FOOTER_TAGLINE]:
    "भारतीय कृषि का पुनर्निर्माण — किसानों को इनपुट, बाज़ार और वित्तीय सेवाओं से जोड़ते हुए, आरंभ से अंत तक।",
  [FOOTER_QUICK_LINKS]: "त्वरित लिंक",
  [FOOTER_LEGAL]: "कानूनी",
  [ADDRESS_1]: "3rd floor, B2/425, Roshan Marg,",
  [ADDRESS_2]: "Chitrakoot, Vaishali Nagar, Jaipur,",
  [ADDRESS_3]: "Rajasthan 302021",
  [PHONE]: "फ़ोन:",
  [EMAIL]: "ईमेल:",

  [SERVICES_TITLE]: "सेवाएं",
  [SERVICES_SUBTITLE]: "किसानों के साथ हर कदम पर",

  [SERVICES_PANEL_LABEL]: "फ्रेशोकार्ट्ज़ सेवाएं",
  [SERVICES_PANEL_HEADING]: "हर खेत की ज़रूरत, शुरू से आखिर तक",
  [SERVICES_INTRO_PARAGRAPH]:
    "जो बीज आप बोते हैं उससे लेकर जो खरीदार आपको भुगतान करता है — फ्रेशोकार्ट्ज़ हर कदम पर साथ है, हमारे एग्री इनपुट दुकान और मार्केट लिंकेज कार्यक्रमों के ज़रिए।",
  [SERVICES_CARD_BTN]: "और जानें",
  [INPUT_BADGE]: "एग्री इनपुट दुकान",
  [INPUT_CARD_DESC]:
    "बीज, उर्वरक और कीटनाशक — हमारे विलेज लेवल एंटरप्रेन्योर नेटवर्क के ज़रिए दूर-दराज के इलाकों तक पहुंचते हैं।",
  [OUTPUT_BADGE]: "मार्केट लिंकेज",
  [OUTPUT_CARD_DESC]:
    "अपनी उपज सीधे अडानी, कारगिल और आईटीसी जैसे खरीदारों को बेचें — पूरी पारदर्शिता, तुरंत भुगतान।",
  [ADVISORY_CARD_DESC]:
    "हमारे कृषि विशेषज्ञ हमेशा आपके साथ हैं — मिट्टी जांच, खेत निरीक्षण, रोग रोकथाम।",
  [FINANCIAL_CARD_DESC]:
    "सीजन के दौरान क्रेडिट सुविधा और कृषि उपकरण के लिए वित्तीय सहायता, किसानों के लिए बनाई गई।",

  [TESTIMONIAL_LABEL]: "किसान समीक्षा",
  [TESTIMONIAL_DESCRIPTION]: "देखिए दूसरे किसान क्या कहते हैं|",

  [PARTNER_EYEBROW]: "हमारा नेटवर्क",
  [PARTNER_LABEL]: "हमारे पार्टनर",
  [PARTNER_DESCRIPTION]:
    "हम कृषि क्षेत्र में सबसे अच्छी कंपनियों के साथ काम करते हैं।",

  [CONTACT_EYEBROW]: "संपर्क में रहें",
  [CONTACT_LABEL]: "संपर्क करें",
  [QUESTION_FORM_TITLE]: "कोई प्रश्न है?",
  [QUESTION_FORM_SUBTITLE]: "हमें बताएं। हमारी टीम आपसे संपर्क करेगी।",

  [OUR_BRANDS_LABEL]: "हमारे ब्रांड",
  [BRANDS_HEADING]: "हर खेत के लिए,",
  [BRANDS_HEADING_EMPHASIS]: "दो भरोसेमंद ब्रांड",
  [BRANDS_SUBTITLE]:
    "फ्रेशोकार्ट्ज़ के प्रमुख ब्रांड किसानों तक विशेष कृषि-इनपुट और मशीनरी सीधे पहुंचाते हैं, हर एक का अपना समर्पित मंच है।",

  [BRAND_NUKRISHI_KICKER]: "कृषि इनपुट",
  [BRAND_NUKRISHI_NAME]: "न्यूकृषि",
  [BRAND_NUKRISHI_DESC]:
    "एक नए युग का कृषि-इनपुट मंच, जो डीलर नेटवर्क के ज़रिए उच्च गुणवत्ता वाले उर्वरक, कीटनाशक और बीज उपलब्ध कराता है।",
  [BRAND_NUKRISHI_TAG_1]: "उर्वरक",
  [BRAND_NUKRISHI_TAG_2]: "कीटनाशक",
  [BRAND_NUKRISHI_TAG_3]: "बीज",

  [BRAND_AMERICANBULLS_KICKER]: "मशीनरी और उपकरण",
  [BRAND_AMERICANBULLS_NAME]: "अमेरिकन बुल्स",
  [BRAND_AMERICANBULLS_DESC]:
    "आधुनिक भारतीय खेतों की ज़रूरतों के लिए मज़बूत कृषि मशीनरी और उपकरण — खेत की तैयारी से लेकर फसल कटाई तक।",
  [BRAND_AMERICANBULLS_TAG_1]: "मशीनरी",
  [BRAND_AMERICANBULLS_TAG_2]: "उपकरण",

  [BRAND_VISIT_CTA]: "वेबसाइट देखें",

  [ABOUT_EYEBROW]: "फ्रेशोकार्ट्ज़ के बारे में",
  [ABOUT_TITLE]: "भारतीय कृषि का कायाकल्प,",
  [ABOUT_TITLE_EMPHASIS]: "बीज से बाज़ार तक",
  [ABOUT_SUBTITLE]:
    "हम भारतीय कृषि के लिए एक मंच बना रहे हैं — किसानों को उनके ज़रूरी इनपुट, विशेषज्ञ सलाह और खरीदारों से जोड़कर, ताकि उत्पादकता और आय दोनों बढ़ें।",
  [ABOUT_STORY_LABEL]: "हमारी कहानी",
  [ABOUT_STORY_HEADING]: "हम क्यों हैं",
  [ABOUT_STORY_PARA_1]:
    "फ्रेशोकार्ट्ज़ की शुरुआत एक सामान्य अवलोकन से हुई: भारतीय किसान कृषि की सबसे बड़ी आपूर्ति श्रृंखला में लगभग अकेले ही आगे बढ़ रहे थे — इनपुट जुटाना, फसल की समस्याओं का समाधान ढूंढना, और उचित खरीदार तलाशना, हर एक अलग संघर्ष, जिसे आपस में जोड़ने वाला कोई नहीं था।",
  [ABOUT_STORY_PARA_2]:
    "इसलिए हमने यह जोड़ बनाया। आज फ्रेशोकार्ट्ज़ कृषि इनपुट, विशेषज्ञ फसल सलाह, उत्पाद बाज़ार पहुंच और वित्तीय सहायता को एक ही मंच पर लाता है — 5 राज्यों में 200,000 से अधिक किसानों तक 40 फार्म केंद्रों और भागीदारों के बढ़ते नेटवर्क के ज़रिए पहुंचते हुए।",
  [ABOUT_STORY_PARA_3]:
    "हम अभी भी शुरुआती दौर में हैं। हर नया फार्म केंद्र और हर नया किसान हमें उस कृषि क्षेत्र के करीब ले जाता है जो उन लोगों के लिए काम करे जो हमें अन्न देते हैं।",
  [ABOUT_STATS_LABEL]: "आंकड़ों में",
  [ABOUT_STATS_HEADING]: "आज हम कहां खड़े हैं",
  [ABOUT_FOUNDERS_LABEL]: "नेतृत्व",
  [ABOUT_FOUNDERS_HEADING]: "संस्थापकों से मिलें",
  [ABOUT_CTA_HEADING]: "हमारे साथ खेती के भविष्य को आकार देना चाहते हैं?",
};
